// @flow
import React, { useState, Suspense } from 'react'
import PropTypes from 'prop-types'
// import Header from '@components/Header'
import { connect } from 'react-redux'
import { setShowGanderce } from '@stores/actions/users'
import Menu from '@components/Menu'
import Guidance from '@components/Guidance'

import Skeleton from '@components/Skeleton'

function WrappedComponent (props) {
  const { history, location, visible, setVisible } = props
  const [hasHeader, setHasHeader] = useState(true)
  const [cowSetting, setCowSetting] = useState({})
  window.History = history
  return (
    <Suspense fallback={<Skeleton location={location} />}>
      <React.Fragment>
        {hasHeader ? <Menu history={history} getCowSetting={info => setCowSetting(info)} /> : null}
        {visible && <Guidance close={() => setVisible(false)} />}
        <props.component history={history} cowSetting={cowSetting} setHasHeader={setHasHeader} />
      </React.Fragment>
    </Suspense>
  )
}
WrappedComponent.defaultProps = {
  history: null,
  location: null,
  visible: false,
  setVisible: () => {}
}
WrappedComponent.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  visible: PropTypes.bool,
  setVisible: PropTypes.func
}
const mapStateToProps = state => ({ visible: state.visible })
const mapDispatchToProps = dispatch => ({
  setVisible: (...args) => {
    dispatch(setShowGanderce(...args))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WrappedComponent)
